import { AutoAwesome } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { useIntl } from 'react-intl';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { useElastixRegistration } from '~/hooks/useElastixRegistration';

interface AutoRegisterToolProps {
    isDisabled: boolean;
    isOpen: boolean;
    onToggle: () => void;
}

export default function AutoRegisterTool({
    isDisabled,
    isOpen,
    onToggle,
}: AutoRegisterToolProps) {
    const { isSubmitting } = useElastixRegistration();
    const intl = useIntl();

    return (
        <ToolbarButton
            icon={
                isSubmitting ? (
                    <CircularProgress size={14} color="inherit" />
                ) : (
                    <AutoAwesome sx={{ fontSize: 14 }} />
                )
            }
            tooltip={intl.formatMessage({
                id: 'workflow.imageRegistration.autoRegister',
            })}
            tooltipPlacement="bottom"
            selected={isOpen}
            disabled={isDisabled}
            onClick={onToggle}
            data-testid="auto-register-tool"
        />
    );
}
